export default __webpack_public_path__ + "static/media/CNo.30-4.9039c6f8.jpg";